/**
 * @description ENDPOITS for all apis
 */

export const ENDPOINTS = {
  AUTH: {
    LOGIN: `/admin/login`,
    LOGOUT: "/admin/logout",
    FORGOT_PASSWORD: "/admin/forgot-password",
    SEND_OTP: "/admin/send-otp",
    VERIFY_OTP: "/admin/verify-otp",
    PROFILE: "/admin/profile",
    CHANGE_PASSWORD: "/admin/change-password",
    RESEND_OTP: "/admin/send-otp",
    EDIT_PROFILE: "/admin/profile",
  },
  DASHBOARD: {
    GET_DASHBOARD: "/admin/user/dashboard",
  },
  USERS: {
    GET_ALL_USERS: "/admin/user/users",
    USER_DETAIL: "/admin/user/user-details",
    BLOCK_UNBLOCK_USER: "/admin/user/status",
  },
  CMS: {
    CMS_lIST: "/admin/cms/list",
    UPDATE_CMS: "/admin/cms",
    CMS_DETAILS: "/admin/cms",
  },
  SITES: {
    SITES_LIST: "/admin/site/list",
    ADD_SITE: "/admin/site",
    UPLOAD_IMAGE: "/common/file/upload/request",
    SITE_DETAIL: "/admin/site",
    UPDATE_STATUS: "/admin/site/status",
  },
  CITIES: {
    CITIES_LIST: "/admin/city/list",
    CITY_DETAIL: "/admin/city",
    CITY_UPDATE: "/admin/city",
    ADD_CITY: "/admin/city",
  },
  REPORTS: {
    REPORTED_LIST: "/admin/report/entityType",
    REPORTED_USER_DETAILS: "/admin/report/user/details",
    REPORTEDBY_LIST: "/admin/report/user/list",
    REPORTED_POST_DETAILS: "/admin/report/post/details",
    FEEDBACK_LIST: "/admin/feedback",
    FEEDBACK_DETAILS: "/admin/feedback/details?feedbackId=",

    DELETED_REPORTED_POST: "/admin/report/action",
    BLOCK_REPORTED_USER: "/admin/report/status",
    WARNING_EMAIL: "/admin/report/warning-mail",
    // POST_REPORT_LIST:"/admin/report/post/list",
  },
  COMMON: {
    DELETE_FILE: "/common/file?key=",
    GENERATE_UPLOAD_URL: "/common/file/upload/request",
    GET_MEDIA_URL: "/common/file/url",
  },
  QUERIES: {
    QUERY_LIST: "/admin/contact-us",
    STATUS: "/admin/contact-us/mark-completed/",
  },
  FEEDBACK: {
    STATUS: "/admin/feedback/mark-completed/",
  },
  EMAIL: {
    LIST: "/admin/email",
    DETAILS: "/admin/email/",
    EDIT: (id) => `/admin/email/${id}`,
  },
  RATINGS_AND_REVIEWS: {
    LIST: "/admin/ratings-and-reviews/list",
    UPDATE_STATUS: (id) => `/admin/ratings-and-reviews/${id}`,
  },
  ARTICLES: {
    ADD_ARTICLES: "/admin/article",
    GET_ARTICLES: "/admin/article/list",
    GET_ARTICLE_DETAILS: "/admin/article/detail",
    UPDATE_ARTICLES: (articleId) => `/admin/article?articleId=${articleId}`,
    DELETE_ARTICLE: (articleId) => `/admin/article?articleId=${articleId}`,
  },
  HOW_TO_VIDEOS: {
    GET_LIST: "/admin/how-to-use/list",
    CREATE: "/admin/how-to-use",
    UPDATE: "/admin/how-to-use",
    DELETE: "/admin/how-to-use",
  },
};
